import { type ListWorkflowRunsResponse } from '@mastra/client-js';
import { useQuery } from '@tanstack/react-query';

import { llmServiceFetcher } from '../LlmServiceFetcher';

interface WorkflowRunQuery {
    workflowId: string;
    resourceId?: string;
    /* `needs_review` is a synthetic status expanded server-side to non-success actionable states */
    status?: string;
    sessionId?: string;
    membershipId?: string;
    enabled?: boolean;
}

export const useGetWorkflowRuns = ({
    workflowId,
    resourceId,
    status,
    sessionId,
    membershipId,
    enabled = true,
}: WorkflowRunQuery) => {
    return useQuery<ListWorkflowRunsResponse, Error>({
        enabled,
        queryKey: [
            'workflowRuns',
            workflowId,
            resourceId,
            status,
            sessionId,
            membershipId,
        ],
        queryFn: async () => {
            const params = new URLSearchParams();
            if (resourceId != null) {
                params.set('resourceId', resourceId);
            }
            if (status != null) {
                params.set('status', status);
            }
            if (sessionId != null) {
                params.set('sessionId', sessionId);
            }
            if (membershipId != null) {
                params.set('membershipId', membershipId);
            }

            return await llmServiceFetcher<ListWorkflowRunsResponse>({
                endpoint: `/workflows/${workflowId}/runs?${params.toString()}`,
                method: 'GET',
            });
        },
    });
};
